// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-unused-vars, import/named */

import Tooltip from "rc-tooltip";
import React from "react";

import { GetHandleProps, GetRailProps, GetTrackProps, SliderItem } from "react-compound-slider";

import "./slider.css";

interface SliderRailProps {
	getRailProps: GetRailProps;
	className?: string;
}

const SliderRail: React.FC<SliderRailProps> = ({ getRailProps, className }) => {
	return (
		<>
			<div className={`mfaRailOuter ${className ?? ""}`} {...getRailProps()} />
			<div className={`mfaRailInner ${className ?? ""}`} />
		</>
	);
};

interface HandleProps {
	domain: number[];
	handle: SliderItem;
	getHandleProps: GetHandleProps;
	vertical?: boolean;
}

// *******************************************************
// KEYBOARD HANDLE COMPONENT
// Uses a button to allow keyboard events
// *******************************************************
const KeyboardHandle: React.FC<HandleProps> = ({
	domain: [min, max],
	handle: { id, value, percent },
	getHandleProps,
	vertical,
}) => {
	return (
		<button
			role="slider"
			className="mfaHandleButton"
			aria-valuemin={min}
			aria-valuemax={max}
			aria-valuenow={value}
			style={{
				top: vertical ? `${percent}%` : "calc(50% + 3px)",
				left: vertical ? "calc(50% + 2px)" : `${percent}%`,
				rotate: vertical ? "-90deg" : "0",
			}}
			{...getHandleProps(id)}
		>
			<svg
				className="mfaHandleSVG"
				xmlns="http://www.w3.org/2000/svg"
				width="17"
				height="18"
				viewBox="0 0 17 18"
				fill="var(--near-black-50)"
				strokeWidth={2}
				stroke="var(--near-black-600)"
			>
				<path d="M7.66315 3.22435C8.05948 2.79198 8.74112 2.79197 9.13746 3.22433L13.6375 8.13342C13.8066 8.31785 13.9004 8.55896 13.9004 8.80915V13.4202C13.9004 13.9725 13.4527 14.4202 12.9004 14.4202H3.9004C3.34811 14.4202 2.9004 13.9724 2.9004 13.4202L2.90045 8.80914C2.90045 8.55895 2.99423 8.31786 3.16329 8.13343L7.66315 3.22435Z" />
			</svg>
		</button>
	);
};

// *******************************************************
// TRACK COMPONENT
// *******************************************************
interface TrackProps {
	source: SliderItem;
	target: SliderItem;
	getTrackProps: GetTrackProps;
	disabled?: boolean;
}

const Track: React.FC<TrackProps> = ({ source, target, getTrackProps }) => {
	return (
		<div
			className="mfaTrack"
			style={{
				top: `${source.percent}%`,
				width: `${target.percent - source.percent}%`,
			}}
			{...getTrackProps()}
		/>
	);
};

// *******************************************************
// TICK COMPONENT
// *******************************************************
interface TickProps {
	tick: SliderItem;
	text: string;
	onClick: () => void;
}

const Tick: React.FC<TickProps> = ({ tick, text, onClick }) => {
	return (
		<Tooltip
			placement="bottom"
			mouseEnterDelay={0}
			mouseLeaveDelay={0}
			trigger="hover"
			motion={{ motionName: "rc-tooltip-zoom" }}
			overlay={<div>{text}</div>}
		>
			<div onClick={onClick} className="mfaTick" style={{ left: `${tick.percent}%` }} />
			{/* <div
				style={{
					position: "absolute",
					marginTop: -5,
					marginLeft: 20,
					fontSize: 10,
					left: `${tick.percent}%`,
					color: "var(--text)"
				}}
			>
				{text}
			</div> */}
		</Tooltip>
	);
};

export const MFASlider = ({ children }: React.PropsWithChildren) => <>{children}</>;

MFASlider.SliderRail = SliderRail;
MFASlider.KeyboardHandle = KeyboardHandle;
MFASlider.Track = Track;
